import { useState, useEffect, lazy, Suspense } from 'react'
import HomePage from './HomePage'
import LoadingSpinner from '../components/LoadingSpinner'

const ReelsPage = lazy(() => import('./ReelsPage'))

const HomePageWrapper = () => {
  const [isMobile, setIsMobile] = useState(false)

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768)
    }
    checkMobile()
    window.addEventListener('resize', checkMobile)
    return () => window.removeEventListener('resize', checkMobile)
  }, [])

  if (isMobile) {
    return (
      <Suspense fallback={<LoadingSpinner />}>
        <ReelsPage />
      </Suspense>
    )
  }
  
  return <HomePage />
}

export default HomePageWrapper